import {
    STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_SUCCESS,
    STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getReferencePricesPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                saveDataError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_SUCCESS:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getReferencePricesPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                saveData: {
                    ...state.takingCarManagement.fastStockLoading.saveData,
                    ...action.data
                },
                saveDataError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getReferencePricesPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                saveDataError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }